module.exports = __webpack_public_path__ + "static/body-fitness-founder-f7cf5565665b4c16112d6183d09ec977.png";